import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  max-width: auto;
  display: flex;
  margin-left: 40px;
  margin-right: 40px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .divFooter {
    display: flex;
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    background-color: #006600;
    color: #ffffff;
    border-width: 0px;
    padding: 10px 10px 12px 10px;
    margin-left: 40px;
    border-radius: 7px;
    margin-top: 2px;
    text-align: center;

    svg {
      margin-right: 7px;
    }

    &:hover {
      background: ${shade(0.2, '#006600')};
    }
  }

  .divContador {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: 40px;
    background-color: #006600;
    padding: 10px 10px 14px 10px;
    border-radius: 7px;
    margin: 2px 0 0 40px;

    span {
      font-size: 16px;
      margin: 0;
    }
  }
`;

export const ContainerBusca = styled.div`
  max-width: auto;
  display: flex;
  padding: 0;
  margin: 0px 40px 0px 40px;
  justify-content: space-between;
  margin-top: 20px;
  overflow-x: auto;

  div.divBusca {
    display: flex;
    flex-direction: row;

    div.divSearch {
      width: 280px;
      div {
        padding-left: 0 !important;
        div {
          padding-left: 8px !important;
        }
      }
    }
  }
`;

export const ContainerTable = styled.div`
  //padding: 0px 20px;
  width: auto;
  margin-left: 40px;
  margin-right: 40px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #006600; //1px solid ${shade(0.8, '#006600')};
  //max-width: 98%;
  max-height: 60vh;
  overflow-x: auto; /** table fica do tamanho da tela com scroll. */
  table {
    width: 100%;
    border-collapse: collapse;
    //border: 1px solid ${shade(0.8, '#006600')};
    border: 1px solid #006600;
    border-top: none;
    th {
      //margin-top: 20px;
      //height: 30px;
      border-bottom: 1px solid #006600;
      justify-content: space-between;
      padding: 5px 40px;
      background-color: #004d00;
      color: #ffffff;
      position: sticky;
      position: -webkit-sticky;
      z-index: 1;
      top: 0;
    }
  }
  tbody {
    border-bottom: 2px solid #666666;
    td {
      border-bottom: 1px solid #004600;
      margin: 20px;
      padding: 5px;
      text-align: center;
      font-size: 14px;

      label.ant-checkbox-wrapper {
        position: relative !important;
        z-index: 0 !important;
      }

      button {
        background-color: transparent;
        border: none;
        color: #fff !important;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.2);
          //color: ${shade(0.3, '#fff')} !important;
        }
      }
    }
    tr {
      /**funcao para fazer as linhas da tabela uma de cada cor de forma alternada.*/
      &:nth-child(even) {
        background-color: #323232;
      }
      &:hover {
        background-color: #454545;
      }
    }
  }
`;
